<template>
  <div>
    <a-form
      ref="formRef"
      class="form selectors"
      :model="formState"
      :rules="rules"
      layout="vertical"
    >
      <!-- <TableControlsSkeleton width="200px" v-if="countLoading < countControlsLoading" />
      v-show="countLoading > countControlsLoading - 1" -->
      <div class="pickers" >
        <a-form-item
          v-if="showEntity"
          label="Empresa"
          name="entityReport1"
        >
          <entity-picker
            :value="formState.entityReport1"
            @update:value="formState.entityReport1 = $event"
            :showAll="typeReport !== ReportTypes.Forms"
            @finishLoading="countLoading++"
          />
        </a-form-item>
        <a-form-item label="Campaña" name="campaignReport1">
          <campaign-picker
            :value="formState.campaignReport1"
            @update:value="formState.campaignReport1 = $event"
            :entity="formState.entityReport1"
            :showAll="typeReport !== ReportTypes.Forms"
          />
        </a-form-item>
        <a-form-item v-if="showBases" label="Base" name="baseReport1">
          <bases-picker
            :value="formState.baseReport1"
            @update:value="formState.baseReport1 = $event"
            :entity="formState.entityReport1"
            :portfolio="formState.campaignReport1"
            @finishLoading="countLoading++"
          />
        </a-form-item>
        <a-form-item v-if="showForms" label="Formulario" name="form">
          <FormPicker
            v-model:value="formState.form"
            :portfolio="formState.campaignReport1"
            @finishLoading="countLoading++"
          />
        </a-form-item>
        <a-form-item
          label="Fecha de inicio"
          name="startValueReport1"
          v-if="typeReport != ReportTypes.ContactProducts"
        >
          <a-date-picker
            v-model:value="formState.startValueReport1"
            :disabled-date="disabledSD"
            format="DD/MM/YYYY"
            placeholder="-- / -- / ----"
            @openChange="StartOpen"
          />
        </a-form-item>
        <a-form-item
          label="Fecha de fin"
          name="endValueReport1"
          v-if="typeReport != ReportTypes.ContactProducts"
        >
          <a-date-picker
            v-model:value="formState.endValueReport1"
            :disabled-date="disabledED"
            format="DD/MM/YYYY"
            placeholder="-- / -- / ----"
            :open="endOpen"
            @openChange="EndOpenChange"
          />
        </a-form-item>
      </div>

      <div class="back">
        <div class="total__wrapper" v-if="countReport > -1">
          <span class="total">{{ countReport }} Registros</span>
        </div>
        <div v-else></div>
        <a-tooltip v-if="validReportType" placement="rightBottom">
          <template #title>
            <span v-if="isGlobalDownloading"> Tiene una descarga pendiente </span>
            <span v-else>
              Se descargarán únicamente los datos de la tabla de acuerdo a los filtros
              seleccionados.
            </span>
          </template>
          <a-button
            type="primary"
            :disabled="!isDisabled || isGlobalDownloading"
            :loading="isLoading"
            @click="donwloadReport"
          >
            Descargar
            <DownloadOutlined />
          </a-button>
        </a-tooltip>
        <a-button v-else type="primary" :disabled="!isDisabled" @click="fetchDataReport">
          Buscar
          <SearchOutlined />
        </a-button>
      </div>
    </a-form>
    <div v-if="validReportType" class="image-center">
      <div class="main-text">Este reporte solo se podrá descargar al aplicar los filtros</div>
    </div>
    <div v-else>
      <campaign-coverage :dataTable="formatedData" :graphicData="graphicData" />
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, reactive, ref, toRaw, watch } from "vue";
import { useStore } from "vuex";
import { DownloadOutlined, SearchOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";

import CampaignCoverage from "@/app/reports/components/charts/campaignCoverage.vue";
import { downloadReportTypifications } from "@/app/reports/services";
import { ReportTypes } from "@/app/reports/utils/enums";
import BasesPicker from "@/app/shared/components/pickers/BasesPicker.vue";
import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import FormPicker from "@/app/shared/components/pickers/FormPicker.vue";
import { useGlobalDownloadState } from "@/app/shared/composables/useGlobalDownloadState";
import { downloadFile } from "@/app/shared/utils/file";
import TableControlsSkeleton from "@/app/shared/components/skeletons/TableControlsSkeleton.vue";
import { usePlanDateRangeValidation } from "@/app/shared/composables/usePlanDateRangeValidation";
import { usePlanSearchRange } from "@/app/shared/composables/usePlanDateRange";
import { RangeConfigKey } from "@/app/shared/utils/planDatePicker";

const typeText = {
  1: {
    excel: "tipificaciones-por-contactos",
    success: "Tipificaciones por Contactos",
  },
  10: {
    excel: "tipificaciones-por-productos",
    success: "Tipificaciones por Productos",
  },
  [ReportTypes.Sells]: {
    excel: "ventas",
    success: "Ventas",
  },
  [ReportTypes.Atc]: {
    excel: "atc",
    success: "ATC",
  },
  [ReportTypes.Forms]: {
    excel: "formulario",
    success: "Formulario",
  },
  [ReportTypes.ContactProducts]: {
    excel: "productos-por-contactos",
    success: "Productos por Contactos",
  },
};

export default defineComponent({
  components: {
    EntityPicker,
    CampaignPicker,
    BasesPicker,
    DownloadOutlined,
    CampaignCoverage,
    SearchOutlined,
    FormPicker,
    TableControlsSkeleton,
  },
  props: { typeReport: { type: Number, default: 1, required: true } },
  setup(props) {
    const store = useStore();
    const userReport1 = computed(() => store.getters["getDataUser"]);

    const { isGlobalDownloading } = useGlobalDownloadState();

    const validReportType = computed(() =>
      [
        1,
        10,
        ReportTypes.Sells,
        ReportTypes.Atc,
        ReportTypes.Forms,
        ReportTypes.ContactProducts,
      ].includes(props.typeReport)
    );
    const endOpen = ref(false);
    const isLoading = ref(false);
    const formatedData = ref([]);
    const graphicData = ref([]);
    const formRef = ref();
    const formState = reactive({
      entityReport1: undefined,
      campaignReport1: undefined,
      baseReport1: undefined,
      startValueReport1: "",
      endValueReport1: "",
    });

    const showEntity = computed(() => userReport1.value?.customer?.type_business == 1);
    const showBases = computed(() => userReport1.value?.customer?.enable_bases);
    const showForms = computed(() => props.typeReport === ReportTypes.Forms);

    const countLoading = ref(0);

    const countControlsLoading = computed(() => {
      return (showEntity.value ? 1 : 0) +
        (showBases.value ? 1 : 0) + 
        (showForms.value ? 1 : 0)
    })

    const rules = {
      entityReport1: [
        { required: userReport1.value?.customer?.type_business == 1, message: "Campo requerido" },
      ],
      campaignReport1: [{ required: true, message: "Campo requerido" }],
      baseReport1: [
        { required: userReport1.value?.customer?.enable_bases, message: "Campo requerido" },
      ],
      form: [{ required: props.typeReport === ReportTypes.Forms, message: "Campo requerido" }],
      startValueReport1: [{ required: true, message: "Campo requerido" }],
      endValueReport1: [{ required: true, message: "Campo requerido" }],
    };

    const isDisabled = computed(() => {
      const hasValidDateRange = formState.startValueReport1 && formState.endValueReport1;

      if (formState.entityReport1 === 0) return hasValidDateRange;

      return (
        (hasValidDateRange || props.typeReport == ReportTypes.ContactProducts) &&
        formState.campaignReport1 !== undefined &&
        (formState.entityReport1 !== undefined ||
          !userReport1.value?.customer?.type_business == 1) &&
        (formState.baseReport1 !== undefined || !userReport1.value?.customer?.enable_bases)
      );
    });

    const countReport = computed(() => store.getters["getReportTypifications"] || undefined);

    const { rangeLimit, typeRange, rangeLimitText } = usePlanSearchRange(null, RangeConfigKey.MessagingSearchRange);

    const { isOutOfRange } = usePlanDateRangeValidation(
      rangeLimit,
      typeRange
    );

    const disabledSD = (startValue) => {
      if (props.typeReport != ReportTypes.ContactProducts) {
        if (!startValue || !formState.endValueReport1) {
          return false;
        }

        return startValue.valueOf() > formState.endValueReport1.valueOf() ||
          isOutOfRange(startValue, formState.endValueReport1);
      } else {
        if (!startValue) {
          return false;
        }
        if (formState.endValueReport1) {
          const maxStartDate = formState.endValueReport1.clone().subtract(31, "days");
          return (
            startValue.valueOf() > formState.endValueReport1.valueOf() ||
            startValue.valueOf() < maxStartDate.valueOf()
          );
        }

        return false;
      }
    };

    const disabledED = (endValue) => {
      if (props.typeReport != ReportTypes.ContactProducts) {
        if (!endValue || !formState.startValueReport1) {
          return false;
        }

        return formState.startValueReport1.valueOf() >= endValue.valueOf() ||
          isOutOfRange(formState.startValueReport1, endValue);
      } else {
        if (!endValue) {
          return false;
        }

        if (formState.startValueReport1) {
          const minEndDate = formState.startValueReport1.clone().add(31, "days");
          return (
            endValue.valueOf() < formState.startValueReport1.valueOf() ||
            endValue.valueOf() > minEndDate.valueOf()
          );
        }

        return false;
      }
    };

    const StartOpen = (open) => {
      if (!open) {
        endOpen.value = true;
      }
    };

    const EndOpenChange = (open) => {
      endOpen.value = open;
    };

    const donwloadReport = async () => {
      isLoading.value = true;
      try {
        console.log(props.typeReport, "props.typeReport");
        console.log(ReportTypes.ContactProducts, "ReportTypes.ContactProducts");
        console.log(toRaw(formState).entityReport1, "toRaw(formState).entityReport1");

        await downloadReportTypifications({
          entity:
            props.typeReport === ReportTypes.ContactProducts
              ? null
              : toRaw(formState).entityReport1,
          campaign: toRaw(formState).campaignReport1,
          base: toRaw(formState).baseReport1,
          form: formState.form,
          startValue:
            props.typeReport === ReportTypes.ContactProducts
              ? null
              : formState.startValueReport1.format("YYYY-MM-DD"),
          endValue:
            props.typeReport === ReportTypes.ContactProducts
              ? null
              : formState.endValueReport1.format("YYYY-MM-DD"),
          type: props.typeReport,
        });
      } catch (error) {
        console.error(error);
        message.error("Ha ocurrido un error");
      }
      isLoading.value = false;
    };

    const fetchDataReport = async () => {
      graphicData.value = await store.dispatch("fetchReportTypifications", {
        entity: toRaw(formState).entityReport1,
        campaign: toRaw(formState).campaignReport1,
        base: toRaw(formState).baseReport1,
        startValue: formState.startValueReport1.format("YYYY-MM-DD"),
        endValue: formState.endValueReport1.format("YYYY-MM-DD"),
        type: 9,
        graphic: true,
      });

      const response = await store.dispatch("fetchReportTypifications", {
        entity: toRaw(formState).entityReport1,
        campaign: toRaw(formState).campaignReport1,
        base: toRaw(formState).baseReport1,
        startValue: formState.startValueReport1.format("YYYY-MM-DD"),
        endValue: formState.endValueReport1.format("YYYY-MM-DD"),
        type: 9,
      });

      const groupArray = response.results.reduce(
        (h, obj) => Object.assign(h, { [obj.group_name]: (h[obj.group_name] || []).concat(obj) }),
        {}
      );
      const entries = Object.entries(groupArray);
      formatedData.value = [];
      entries.forEach((item) => {
        const obj = {
          group_name: item[0],
          results: item[1],
          total: item[1].reduce(function (acc, item_) {
            return acc + item_.total;
          }, 0),
        };
        formatedData.value.push(obj);
      });
      console.log(graphicData.value);
    };

    watch(userReport1, (newValue) => {
      if (newValue.customer.type_business == 2) {
        formState.entityReport1.value = 1;
      }
    });

    watch(
      formState,
      () => {
        if (
          isDisabled.value &&
          validReportType.value &&
          props.typeReport != ReportTypes.ContactProducts
        ) {
          store.dispatch("fetchReportTypifications", {
            entity: toRaw(formState).entityReport1,
            campaign: toRaw(formState).campaignReport1,
            base: toRaw(formState).baseReport1,
            form: formState.form,
            startValue: formState.startValueReport1.format("YYYY-MM-DD"),
            endValue: formState.endValueReport1.format("YYYY-MM-DD"),
            type: props.typeReport,
          });
        }
      },
      { deep: false }
    );

    return {
      validReportType,
      formRef,
      formState,
      rules,
      userReport1,
      endOpen,
      disabledSD,
      disabledED,
      StartOpen,
      EndOpenChange,
      isDisabled,
      countReport,
      donwloadReport,
      fetchDataReport,
      formatedData,
      graphicData,
      isLoading,
      ReportTypes,
      isGlobalDownloading,
      showEntity,
      showBases,
      countControlsLoading,
      countLoading,
      showForms,
    };
  },
});
</script>

<style lang="sass" scoped>
.selectors
  // display: grid
  // grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr
  // gap: 12px
  padding: 15px 5px 5px
  display: flex
  justify-content: space-between

.pickers
  display: flex
  gap: 12px

  & > .ant-form-item
    min-width: 180px

:deep(.ant-calendar-picker-icon)
  top: 50% !important
:deep(.ant-calendar-picker)
  width: 100%

:deep(.ant-form-item)
  margin-bottom: 0

.back
  text-align: center
  display: flex
  justify-content: space-between
  align-items: flex-end
  width: 220px

.main-text
  font-size: 14px
  font-style: normal
  font-weight: 400
  line-height: 28px
  letter-spacing: 0em
  text-align: center
  color: $gray-7
.total
  color: $gray-8

  &__wrapper
    height: 32px
    display: grid
    place-content: center
</style>
